<div class="container-xxl gx-lg-10 gx-xxl-0">
    <div #swiper class="swiper" [class.is-client]="isClient">
        <div class="swiper-wrapper">
            @for (partner of partners; track partner.slug) {
                <div class="swiper-slide">
                    <a [routerLink]="['/partners', partner.slug] | localize">
                        <img src="assets/images/partners/{{ partner.logoURL }}" [alt]="partner.name" />
                        <div class="partner-name">
                            {{ partner.name }}
                        </div>
                    </a>
                </div>
            }
        </div>
    </div>

    <div class="swiper-controls mt-5">
        <div class="container-xxl gx-9 gx-md-7 gx-lg-10 gx-xxl-0 mb-13">
            <div class="d-flex align-items-center justify-content-center">
                <div #swiperPagination class="pagination"></div>
            </div>
        </div>
    </div>
</div>
